import { forwardRef } from 'react';

type Props = {
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  name: string;
  label?: string;
  appendedEl?: React.ReactNode;
  inputClassName?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  {
    value,
    onChange,
    placeholder,
    type = 'text',
    className = '',
    inputClassName = '',
    name,
    label,
    appendedEl,
    inputProps = {},
    onKeyDown,
  },
  ref
) {
  return (
    <div className={`relative flex flex-col ${className} w-full`}>
      {label && (
        <label
          htmlFor={name}
          className="mb-[16px] text-left  rtl:text-right text-[0.75em] font-medium uppercase leading-[0.825em] tracking-[0.053em]"
        >
          {label}
        </label>
      )}
      <input
        onKeyDown={onKeyDown}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        className={`text-[1em] w-full border border-opacity-20 placeholder-primary placeholder-opacity-60  outline-none focus:border-primary focus:!ring-0 focus:!ring-transparent focus:!ring-offset-0
 ${inputClassName}`}
        name={name}
        autoComplete="off"
        ref={ref}
        {...inputProps}
      />
      {appendedEl && (
        <div className="absolute bottom-[1em] end-[1em] right-unset">{appendedEl}</div>
      )}
    </div>
  );
});
